module.exports = __webpack_public_path__ + "static/img/tap-right-1.e1f1fc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/tap-right-1.png
// module id = 9j+D
// module chunks = 1